import { render, staticRenderFns } from "./zylbaobiao.vue?vue&type=template&id=0b7b4b44&scoped=true"
import script from "./zylbaobiao.vue?vue&type=script&lang=js"
export * from "./zylbaobiao.vue?vue&type=script&lang=js"
import style0 from "./zylbaobiao.vue?vue&type=style&index=0&id=0b7b4b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7b4b44",
  null
  
)

export default component.exports